import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error',
  standalone: false,
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit, OnDestroy {
  errorMessage?: string;
  errorKey?: string;
  langChangeSubscription?: Subscription;
  statusCode?: number;

  constructor(
    private translateService: TranslateService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.data.subscribe((routeData) => {
      if (routeData.errorMessage) {
        this.errorKey = routeData.errorMessage;
        this.statusCode = this.deriveStatusCode(this.errorKey);
        this.getErrorMessageTranslation();
        this.langChangeSubscription = this.translateService.onLangChange.subscribe(() =>
          this.getErrorMessageTranslation()
        );
      }
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  private getErrorMessageTranslation(): void {
    this.errorMessage = '';
    if (this.errorKey) {
      this.translateService
        .get(this.errorKey)
        .subscribe((translatedErrorMessage) => (this.errorMessage = translatedErrorMessage));
    }
  }

  private deriveStatusCode(errorKey?: string): number | undefined {
    if (!errorKey) return undefined;
    if (errorKey.endsWith('404')) return 404;
    if (errorKey.endsWith('403')) return 403;
    return undefined;
  }

  goBack(): void {
    window.history.back();
  }
}
